var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({staticClass:"cs-icon-button",class:{ selected: _vm.selected, disabled: _vm.disabled }},'button',_vm.$attrs,false),_vm.$listeners),[_c('cs-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }